module.exports = __webpack_public_path__ + "static/img/10.8ac892c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/10.png
// module id = xZ9K
// module chunks = 0